import VerifyEmailSecure from './verifyEmailSecure';

export default VerifyEmailSecure;
